export default __webpack_public_path__ + "static/media/yellow-alignment.a754d97a.svg";